// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"089f3843","453":"0840ffe8","732":"fecb7dfe","977":"597cc24a"}[chunkId] + ".chunk.js";
};